import { IArticleCategory } from "@/app/types";
import { ITableRowColumn } from "@/core/components/table/AppTableRow";

const articleCategoryColumns: ITableRowColumn<IArticleCategory>[] = [
  {
    header: { id: "title_fr", label: "label.name_fr", align: "left" },
    type: "avatar",
    title: (row) => row.title?.fr,
    avatarUrl: (row) => row?.title?.fr ?? "",
  },
  {
    header: {
      id: "title_en",
      label: "label.name_en",
      align: "left",
    },
    title: (row) => row?.title?.en ?? "",
    align: "left",
  },
];

export default articleCategoryColumns;
